module.exports = __webpack_public_path__ + "post-listing-block-4-overlay-wide-3Rk2wSs.png";